import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MFChannel } from '../../Components/SDK';
import { setChannelInfo } from '../../Slice';
import Store from '../../Store';

export const getChannelInfo = ({ channelId, accessUri }) => {
   const channelInfoMap = Store.getState()?.channelInfoData?.channelInfo || {};
   if (channelId && channelInfoMap[channelId]) {
      return channelInfoMap[channelId];
   }
   if (accessUri) {
      const accessLower = String(accessUri).toLowerCase();
      for (const info of Object.values(channelInfoMap)) {
         if (info?.accessUri && typeof info.accessUri === 'string' && info.accessUri.toLowerCase() === accessLower) {
            return info;
         }
      }
   }
   return undefined;
};

export function useChannelInfo({ channelId, accessUri }) {
   const [info, setInfo] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
   const dispatch = useDispatch();
   const [error, setError] = useState(null);

   const fetchInfo = useCallback(() => {

      if (!channelId && !accessUri) {
         return;
      }

      setIsLoading(true);
      setError(null);
      const timer = setTimeout(() => {
         MFChannel.fetchChannelInfo({ channelId, accessUri })
            .then(response => {
               if (response && response.statusCode === 200) {
                  
                  dispatch(setChannelInfo(response.data));
                  setInfo(response.data);
               } else {
                  const err = response || { message: 'Failed to fetch channel info' };
                  setError(err);
               }
            })
            .catch(err => {
               setError(err);
            })
            .finally(() => setIsLoading(false));
      }, 1000);

      // Return cleanup function
      return () => clearTimeout(timer);
   }, [channelId, accessUri, dispatch]);

   useEffect(() => {
      fetchInfo();
   }, [fetchInfo]);

   return { info, isLoading, error, refetch: fetchInfo };
}

export default useChannelInfo;
